// extracted by mini-css-extract-plugin
module.exports = {"divider":"ParentMenuComponent_divider__1YfOH"};